module.exports = __webpack_public_path__ + "img/[玫瑰].c8b57b59.svg";